import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { User, PanelMember, Discussion } from "../../../../../models";
import { PanelService } from "../../../../../services";

@Component({
  selector: "credential-editor-form",
  templateUrl: "./credential-editor-form.component.html",
  styleUrls: [
    "./credential-editor-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CredentialEditorForm implements OnInit {
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "7rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    uploadUrl: "v1/images",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  public defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";
  public credentialToPost: any = {};
  public isSubmitting = false;
  public credentialField = new FormControl();
  public credentialFormErrors = {};

  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() canModifyDiscussion: boolean;

  ngOnInit() {
    this.initiateEditField();
  }

  constructor(private panelService: PanelService) {
    this.credentialField.valueChanges.subscribe((value) => {
      this.credentialToPost["credential"] = value;
    });
  }

  public initiateEditField() {
    if (this.currentPanelMember) {
      this.credentialToPost = {};
      this.credentialField.setValue(this.currentPanelMember.credential);
    }
  }

  public saveCredential() {
    this.isSubmitting = true;
    this.credentialFormErrors = {};

    if (this.currentPanelMember || this.canModifyDiscussion) {
      this.panelService
        .saveCredential(
          this.discussion,
          this.currentPanelMember,
          this.credentialToPost
        )
        .subscribe(
          (credential) => {
            this.credentialField.reset("");
            this.isSubmitting = false;
            this.fireSuccessAlert();
          },
          (errors) => {
            this.isSubmitting = false;
            this.credentialFormErrors = errors;
            this.fireErrorAlert();
          }
        );
    } else {
      this.isSubmitting = false;
      this.fireBlockedAlert();
    }
  }

  public openCredentialPostConfirmation() {
    Swal.fire({
      title: "Publish credential?",
      text: "Sure you want to publish this credential?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, publish!",
    }).then((result) => {
      if (result.value) {
        this.saveCredential();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Published",
      text: "Your credential has been published",
      type: "success",
    }).then(function () {
      window.location.reload();
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }

  public fireBlockedAlert() {
    Swal.fire("Eish!", "You are not authorized to make this edit", "warning");
  }
}
